import React from "react"
import { Link, useStaticQuery, graphql, Script } from "gatsby"
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image"
import { Menu, Transition, Popover } from '@headlessui/react'
import { Bars3Icon } from '@heroicons/react/20/solid'
import MobileNav from "./general/mobileNav"
import TaalreisMenu from "./general/taalreisMenu"
import GroepMenu from "./general/groepMenu"
import DropdownMenu from "./general/bestemmingen"
import ThemaMenu from "./general/themas"
import { Fragment, useRef, useState, useEffect } from "react"
import {useLocation } from '@reach/router';
// import ChatButton from "./general/chatButton"
// import WhatsAppButton from "./general/whatsAppButton"
import ChatAndWhatsAppButtons from "./general/ChatAndWhatsAppButtons";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Mousewheel, Keyboard, Pagination } from "swiper/modules";


// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const Layout = ({ isHomePage, children }) => {
  const {
    wp: {
      generalSettings: { title },
    },
  } = useStaticQuery(graphql`
    query LayoutQuery {
      wp {
        generalSettings {
          title
          description
        }
      }
    }
  `)

  const location = useLocation();





  const [isVisible, setIsVisible] = useState(true); 

  useEffect(() => {
    const handleClose = () => {
      setIsVisible(false);
    };

    // Voeg een eventlistener toe voor wanneer de gebruiker de pagina verlaat
    window.addEventListener("beforeunload", handleClose);

    // Verwijder de eventlistener wanneer de component wordt verwijderd
    return () => {
      window.removeEventListener("beforeunload", handleClose);
    };
  }, []); // Voer dit effect alleen uit bij de eerste render

  const handleToggle = () => {
    setIsVisible((prevVisible) => !prevVisible);
  };



    // Functie om het huidige jaar te krijgen
    const getCurrentYear = () => {
      return new Date().getFullYear();
    };



    const lang = location.pathname.startsWith("/en") ? "en" : "nl";
    const surfVakantiesLink = lang === "en" ? "/en/surf-camps" : "/surfvakanties";
    






  return (

//Ontvang ons <a className="underline bold mx-1" href="https://www.bol.com/nl/nl/p/de-surfawhile-surf-guide/9300000095471851/">e-book</a>  t.w.v. € 19,95 gratis bij jouw boeking
    
  
<div className="ml-0 border-n" data-is-root-path={isHomePage}>

    
    <div className="w-full pt-1 top-0 h-7 bg-black font-inter text-sm md:text-sm">


<nav className="flex justify-between items-center text-white mx-5 font-semibold sm:mr-2 md:mr-20 container w-full mx-auto">
  {/* Plaats de WhatsAppButton eerst en links */}
  <div className="ml-3">
  <ChatAndWhatsAppButtons />

  
  </div>
  {/* Groepeer de overige links in een div en recht uitlijnen */}
  <div className="flex justify-end">
    <a href="https://shop.surfawhile.com" className="mx-2 hidden md:inline">
      Webshop
    </a>
    <Link to="/surf-blog" className="mx-2 hidden md:inline">
      Blog
    </Link>
    <Link to="/over-ons" className="mx-2 hidden md:inline">
      Over Ons
    </Link>
    <Link to="/contact" className="mx-2 hidden md:inline">
      Contact
    </Link>
   
  </div>
</nav>
</div>
<div className="w-full bg-stone-100">

<header className="container w-full mx-auto">
  <nav className="flex py-5 z-30 h-16 relative w-full flex items-center justify-between text-slate-800">
    <div className="flex items-center">
      <Link id="logo" className="" to="/">
        <img
          src="https://wp.surfawhile.com/wp-content/uploads/2023/10/Black.svg"
          alt="SurfaWhile Logo"
          className="w-200 mt-4 ml-2 hidden md:inline"
          style={{ width: 200 }} // Breedte van de afbeelding
        />

      <img
          src="https://wp.surfawhile.com/wp-content/uploads/2024/09/Vector-3.png"
          alt="SurfaWhile Logo"
          className="mt-2 ml-2 md:hidden"
          style={{ width: 24 }} // Breedte van de afbeelding
        />

      </Link>


    </div>
    
    <div id="main-menu" className="bg-stone-100 flex items-center">
    
    {/* <Link to={surfVakantiesLink} className="hidden font-semibold lg:inline-flex font-inter justify-center rounded-md px-3 py-2 hover:bg-opacity-30 hover:no-underline hover:after:content-[''] hover:after:absolute hover:after:left-3 hover:after:w-40 hover:after:bottom-[-2px] hover:after:h-[2px] hover:after:bg-current transition-all duration-300">
                {lang === "en" ? "All Surf Camps" : "Alle Surfvakanties"}
    </Link> */}

<Link
  to={surfVakantiesLink}
  className="hidden font-semibold lg:inline-flex font-inter justify-center px-3 py-2 relative group hover:no-underline"
>
  <span className="relative z-10">
    {lang === "en" ? "All Surf Camps" : "Alle Surfvakanties"}
  </span>
  <span className="absolute bottom-0 left-3 w-0 h-[2px] bg-current transition-all duration-300 group-hover:w-[calc(100%-1.5rem)]"></span>
</Link>

      
      <DropdownMenu />
      <ThemaMenu />
      
      <div className="hidden xl:inline-flex">
        <TaalreisMenu />
      </div>

      <div className="hidden xl:inline-flex">
        <GroepMenu />
      </div>

  <Link to="/surfvakanties/aanbiedingen">
        <button style={{
          padding: "10px 30px 10px 20px",
          borderRadius: "5px",
          border: "none",
          cursor: "pointer",
        }} class="mr-1 bg-red-500 text-sm hover:bg-red-600 hover:shadow-xl text-white font-semibold py-2 shadow font-inter text-md flex items-center space-x-2 transition duration-300 ease-in-out">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
      <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.902 7.098a3.75 3.75 0 0 1 3.903-.884.75.75 0 1 0 .498-1.415A5.25 5.25 0 0 0 8.005 9.75H7.5a.75.75 0 0 0 0 1.5h.054a5.281 5.281 0 0 0 0 1.5H7.5a.75.75 0 0 0 0 1.5h.505a5.25 5.25 0 0 0 6.494 2.701.75.75 0 1 0-.498-1.415 3.75 3.75 0 0 1-4.252-1.286h3.001a.75.75 0 0 0 0-1.5H9.075a3.77 3.77 0 0 1 0-1.5h3.675a.75.75 0 0 0 0-1.5h-3c.105-.14.221-.274.348-.402Z" clip-rule="evenodd" />
    </svg>
    <span>Aanbiedingen</span>
  </button>
  </Link>
  
      {/* <ChatButton /> */}

    </div>

    <div className="lg:hidden inline">
      <MobileNav />
    </div>
  </nav>
</header>

</div>

<main className="bg-white font-normal">{children}</main>





<div className="w-full bg-sky-200 p-2">
  
  <div className="container mx-auto">
    <h2 className="text-3xl">Zij gingen jou voor</h2>
    
  </div>
</div>


<div className="my-0 p-5 bg-sky-200 rounded-lg">
  <Swiper
    spaceBetween={10}
    id="theme-swiper"
    cssMode={true}
    navigation={{
      nextEl: ".theme-next",
      prevEl: ".theme-prev"
    }}
    breakpoints={{
      640: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      1024: {
        slidesPerView: 1,
      },
    }}
    pagination={true}
    mousewheel={true}
    keyboard={true}
    modules={[Pagination, Mousewheel, Keyboard, Navigation]}
    className="mySwiper"
  >

    <SwiperSlide>

      <div className="flex my-0 p-5 bg-sky-200 rounded-lg flex-col sm:flex-row items-center">
        <div className="flex-shrink-0 flex flex-col items-center p-5 justify-between h-full">
  
          <img className="w-48 h-48 mb-2 rounded-full" src={`https://wp.surfawhile.com/wp-content/uploads/2024/05/1000055628-1.webp`} alt="Hans' afbeelding" />
        </div>
        <div className="flex-grow p-5 flex flex-col justify-between"> 
          <h2 className="text-2xl sm:text-3xl my-2 uppercase text-center sm:text-left">Isabel</h2>
          <span className="text-sm font-semibold font-inter text-slate-500">Dreamsea Surf Camp Moliets</span>
          <blockquote className="text-lg italic text-gray-700 border-0 -ml-5">
            <p className="font-inter">
              "Dankzij de hulp van SurfaWhile de beste reis gemaakt die ik mij kon wensen. Het was mijn eerste solo trip en door onnodige angst voor het onbekende had ik deze trip bijna aan mij voorbij laten gaan. Dankzij de snelle reacties en hulp bij het uitkiezen van het (voor mij) juiste kamp kwam ik terecht bij dreamsea surfcamp in Moliets, dit is een perfecte match gebleken. Ik heb zo ontzettend genoten en ik kan nu al niet wachten om terug te keren, ik ben een familie en talloze waardevolle herinneringen rijker. Nogmaals mijn dank, ik had dit voor geen goud willen missen.. 💛"
            </p>
          </blockquote>
        </div>
      </div>
    </SwiperSlide>
    
    <SwiperSlide>
      <div className="flex my-0 p-5 bg-sky-200 rounded-lg flex-col sm:flex-row items-center">
        <div className="flex-shrink-0 flex flex-col items-center p-5 justify-between h-full">
  
          <img className="w-48 h-48 mb-2 rounded-full" src={`https://wp.surfawhile.com/wp-content/uploads/2024/05/unnamed-1.jpg`} alt="Hans' afbeelding" />
        </div>
        <div className="flex-grow p-5 flex flex-col justify-between"> 
          <h2 className="text-2xl sm:text-3xl my-2 uppercase text-center sm:text-left">Ian</h2>
          <span className="text-sm font-semibold font-inter text-slate-500">Surf Cascais</span>
          <blockquote className="text-lg italic text-gray-700 border-0 -ml-5">
            <p className="font-inter">
              "Een geweldige surfvakantie gehad in Cascais! Fantastische lesgevers in een prachtig verzorgde surfvilla. Aanrader!
              Opgelet: je kan wel terugkomen met een surfverslaving :-) "
            </p>
          </blockquote>
        </div>
      </div>
    </SwiperSlide>

    <SwiperSlide>
      <div className="flex my-0 p-5 bg-sky-200 rounded-lg flex-col sm:flex-row items-center">
        <div className="flex-shrink-0 flex flex-col items-center p-5 justify-between h-full">
  
          <img className="w-48 h-48 mb-2 rounded-full" src={`https://wp.surfawhile.com/wp-content/uploads/2024/05/Foto-1.jpeg`} alt="Hans' afbeelding" />
        </div>
        <div className="flex-grow p-5 flex flex-col justify-between"> 
          <h2 className="text-2xl sm:text-3xl my-2 uppercase text-center sm:text-left">Bente</h2>
          <span className="text-sm font-semibold font-inter text-slate-500">Dreamsea Surf Camp Moliets</span>
          <blockquote className="text-lg italic text-gray-700 border-0 -ml-5">
            <p className="font-inter">
              "Geweldige surftrip met leuke instructeurs, gekke feestjes en de vrijheid om ook te doen wat je wilt! 10/10 zou het aanbevelen!"
            </p>
          </blockquote>
        </div>
      </div>
    </SwiperSlide>


  </Swiper>
</div>





<footer className="w-full bg-sky-50 flex flex-col footer-top">
  <div className="container mx-auto w-full">
    <div className="grid grid-cols-1 md:grid-cols-3 font-inter p-2 ">
                
    <div className="">
        <ul className="list-none space-y-1 my-3">
          <li><h4 className="text-xl uppercase">Surfvakanties per land</h4></li>
          <li className="hover:underline"><Link to="/surfvakanties/frankrijk">Frankrijk</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/spanje">Spanje</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/portugal">Portugal</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/marokko">Marokko</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/mexico">Mexico</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/nicaragua">Nicaragua</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/costa-rica">Costa Rica</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/ecuador">Ecuador</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/sri-lanka">Sri Lanka</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/indonesie">Indonesië</Link></li>
        </ul>
 
        <ul className="list-none space-y-1 mt-3">
          <li><h4 className="text-xl uppercase">Surfvakanties per bestemming</h4></li>
          <li className="hover:underline"><Link to="/surfvakanties/frankrijk/moliets">Moliets, Frankrijk</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/frankrijk/mimizan">Mimizan, Frankrijk</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/frankrijk/biarritz">Biarritz, Frankrijk</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/spanje/san-sebastian">San Sebastian, Spanje</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/spanje/zarautz">Zarautz, Spanje</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/spanje/cantabrie">Cantabrië, Spanje</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/spanje/canarische-eilanden">Canarische Eilanden, Spanje</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/spanje/lanzarote">Lanzarote, Spanje</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/spanje/fuerteventura">Fuerteventura, Spanje</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/portugal/porto">Porto, Portugal</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/portugal/peniche">Peniche, Portugal</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/portugal/ericeira">Ericeira, Portugal</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/portugal/lissabon">Lissabon, Portugal</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/portugal/vila-nova-de-milfontes">Vila Nova de Milfontes, Portugal</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/portugal/aljezur">Aljezur, Portugal</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/marokko/imsouane">Imsouane, Marokko</Link></li>
        </ul>
      </div>

      <div>
        <ul className="list-none space-y-1 mt-3">
          <li><h4 className="text-xl uppercase">Surfvakanties per thema</h4></li>
          <li className="hover:underline"><Link to="/surfvakanties/families">Families</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/yoga">Surf &amp; Yoga</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/surf-en-taalreizen">Surf &amp; Taal</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/busreizen">Busreizen</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/glamping">Glamping</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/surfkampen">Surfkampen</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/surflodges">Surflodges</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/solo-reizigers">Solo-reizigers</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/koppels">Koppels</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/jongeren">Juniors (18-)</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/volwassenen">Volwassenen</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/18plus">Volwassenen (18+)</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/20plus">Volwassenen (20+)</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/25plus">Volwassenen (25+)</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/30plus">Volwassenen (30+)</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/lente">Lente</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/zomer">Zomer</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/herfstvakantie">Herfst</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/winter">Winter</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/kitesurfen">Kitesurfen</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/digital-nomads">Digital nomads</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/dreamsea">Dreamsea Surf Camps</Link></li>
          <li className="hover:underline"><Link to="/surfvakanties/aanbiedingen">Aanbiedingen</Link></li>

        </ul>
      </div>
      <div>
                  <ul className="list-none space-y-1 mt-3">
                   <li><h4 className="text-xl uppercase">Info &amp; Inspiratie</h4></li>
                    <li className="hover:underline"><Link to="/over-ons">Over SurfaWhile</Link></li>
                    <li className="hover:underline"><Link to="/persoonlijk-advies">Persoonlijk advies</Link></li>
                    <li className="hover:underline"><Link to="/contact">Contact</Link></li>
                    <li className="hover:underline"><Link to="/reviews">Reviews</Link></li>
                    <li className="hover:underline"><Link to="https://surfawhile.com/review-form">Schrijf een review</Link></li>
                    <li className="hover:underline"><a href="https://shop.surfawhile.com">Webshop</a></li>
                    <li className="hover:underline"><Link to="https://wp.surfawhile.com/wp-content/uploads/2023/03/Coconut-Travel-Collective-B.V.-Algemene-Voorwaarden-SurfaWhile-1.pdf">Algemene voorwaarden</Link></li>
                  </ul>

                  <ul className="list-none space-y-1 mt-3">
                  <li><h4 className="text-xl uppercase">Volg Ons</h4></li>
                    <li className="hover:underline"><Link to="https://www.instagram.com/surfawhile/">Instagram</Link></li>
                    <li className="hover:underline"><Link to="https://www.facebook.com/SurfaWhile/">Facebook</Link></li>
                    <li className="hover:underline"><Link to="https://www.tiktok.com/@surfawhile">TikTok</Link></li>
                    <li className="hover:underline"><Link to="https://www.youtube.com/@surfawhile">YouTube</Link></li>
                    <li className="hover:underline"><Link to="https://www.linkedin.com/company/10490090">LinkedIn</Link></li>                  
                  </ul>

                  <div className="my-5 font-inter">
                  <ul className="list-none">
                    <li className="my-2">
                      SurfaWhile is aangesloten bij:</li>
  <li className="my-2">
    <div className="flex items-center">
      <img className="h-auto w-32 block mr-2" src="https://wp.surfawhile.com/wp-content/uploads/2024/03/logo-vvkr-square.png" alt="VVKR Logo" />
     </div>
    
  </li>
  <li className="my-2">Lidnummer: 18038</li>
  
  <li className="my-2">
    <div className="flex items-center">
      <img className="h-auto w-32 block mr-2" src="https://wp.surfawhile.com/wp-content/uploads/2024/03/GGTO_logo_Blauw.png" alt="GGTO Logo" />
      <br />
    </div>
  </li>
  <li className="my-2">Lidnummer: 1395</li>
</ul>
                    </div>
                  </div>

               
      </div>
 



<div className="w-full font-inter bg-sky-50 h-24 flex justify-center items-center mx-auto footer-bottom">
     Copyright SurfaWhile, {getCurrentYear()}
    </div>
    
    </div>
    </footer>
    
    </div>


);
};

export default Layout
